module.exports = __webpack_public_path__ + "static/media/awesomerewards.38921067.png";